import { IndexList } from 'react-uni-comps';
import {Stack, Typography} from '@mui/material'
import {useSelector} from "react-redux";
import {useEffect, useMemo} from "react";
import { groupBy } from "es-toolkit/array";
import {getDefaultCountry, getNationIcon, filterCountries as _filterCountries} from '@/utils/utils'

const NationIndexBar = (props) => {
  const { dataSource, onSelect, selected, showAreaCode } = props;
  const {countries, locationInfo} = useSelector((state) => state.app);
  useEffect(() => {
    if (selected) {
      const _selected = countries.find(_ => _.code3 === selected.code3)

    }
  }, [selected])

  const onItemClick = (item) => {
    onSelect && onSelect(item);
  }

  return (<>
    <IndexList
      style={{ height: '100vh' }}
      data={dataSource}
      onItemClick={(item) => {
        onItemClick(item)
      }}
    />
  </>)
}

export default NationIndexBar;